import { pageSizes } from 'containers/CreativePreview/constants';
import React, { useEffect } from 'react';
import { Dropdown, DropdownButton, Form } from 'react-bootstrap';
import useQuery from 'reusable/customHooks/useQuery';
import { StyledPagenation } from './style';

function Pagination({ dataLength }) {
  const [query, setQuery] = useQuery();
  const pageIndex = Number(query.get('page')) || 1;
  const pageSize = Number(query.get('pageSize')) || 5;
  const maxPages = Math.ceil(dataLength / pageSize);

  useEffect(() => {
    if (Number(pageIndex) > maxPages) {
      setQuery('page', String(maxPages));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxPages, pageIndex]);

  return (
    <StyledPagenation>
      <Form.Group className="form-group">
        <Form.Label>Page : </Form.Label>
        <Form.Control
          type="number"
          min={1}
          max={maxPages}
          value={pageIndex}
          onChange={e => {
            setQuery('page', e.target.value);
          }}
        />
        OF {maxPages}
      </Form.Group>
      <DropdownButton title={`Show ${pageSize}`}>
        {pageSizes.map(size => (
          <Dropdown.Item
            onClick={() => setQuery('pageSize', String(size))}
            key={size}
          >
            Show {size}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </StyledPagenation>
  );
}

export default Pagination;
